var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4665 36.166H18.1998C17.4998 36.166 16.7998 35.6994 16.7998 34.766V24.4994C16.7998 23.7994 17.4998 23.0994 18.1998 23.0994H21.4665C22.1665 23.0994 22.8665 23.7994 22.8665 24.4994V34.766C22.8665 35.6994 22.1665 36.166 21.4665 36.166Z",
    stroke: "#8ACB00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8652 33.3665L25.4319 35.4665C25.8986 35.9331 26.5986 36.1665 27.2986 36.1665H35.6986C36.6319 36.1665 37.5652 35.4665 38.0319 34.5331L39.6652 28.4665C39.8986 27.5331 39.6652 26.5998 39.1986 25.8998C38.4986 24.9665 37.5652 24.4998 36.6319 24.4998H35.2319H32.8986V20.5331C32.8986 17.4998 28.9319 16.5665 27.5319 18.8998L23.0986 26.1331",
    stroke: "#8ACB00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3995 7.69955L32.8995 6.06622C34.5329 5.36622 36.3995 5.83289 37.0995 7.46622L38.9662 10.7329C39.4329 11.6662 40.3662 12.1329 41.2995 12.3662L45.0329 13.0662C46.6662 13.2996 47.8329 14.9329 47.5995 16.7996L47.1329 20.5329C46.8995 21.4662 47.3662 22.3996 48.0662 23.3329L50.6329 26.1329C51.7995 27.2996 51.7995 29.3996 50.6329 30.5662L48.0662 33.3662C47.3662 34.0662 47.1329 34.9996 47.1329 36.1662L47.5995 39.8996C47.8329 41.5329 46.6662 43.1662 45.0329 43.6329L41.2995 44.3329C40.3662 44.5662 39.4329 45.0329 38.9662 45.9662L37.0995 49.2329C36.3995 50.8662 34.2995 51.3329 32.8995 50.6329L29.3995 48.9996C28.4662 48.5329 27.5329 48.5329 26.5995 48.9996L23.0995 50.6329C21.4662 51.3329 19.5995 50.8662 18.8995 49.2329L17.0329 45.9662C16.5662 45.0329 15.6329 44.5662 14.6995 44.3329L10.9662 43.6329C9.33288 43.3996 8.16621 41.7662 8.39954 39.8996L8.86621 36.1662C9.09954 35.2329 8.63288 34.2996 7.93288 33.3662L5.36621 30.5662C4.19954 29.3996 4.19954 27.2996 5.36621 26.1329L7.93288 23.3329C8.63288 22.6329 8.86621 21.6996 8.86621 20.5329L8.39954 16.7996C8.16621 15.1662 9.33288 13.5329 10.9662 13.0662L14.6995 12.3662C15.6329 12.1329 16.5662 11.6662 17.0329 10.7329L18.8995 7.46622C19.5995 5.83289 21.6995 5.36622 23.0995 6.06622L26.5995 7.69955C27.5329 8.16622 28.4662 8.16622 29.3995 7.69955Z",
    stroke: "#8ACB00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.12a84a74c49026d6f1c590bc7bfb9a55.svg";
export { ForwardRef as ReactComponent };